import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnInit, OnDestroy, ElementRef, Renderer2, HostListener} from '@angular/core';
import { MenuItems } from '../../shared/menu-items/menu-items';
import { SidenavService } from '@services/varios/sidenav.service';
import { SideNavOpn, SideNavCls, LOGO_SISTEMA, LOGO_SISTEMA_TEXTO, environment } from "@env/environment";
import { AuthService } from '@services/auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-full-layout',
  templateUrl: 'full.component.html',
  styleUrls: []
})

export class FullComponent implements OnInit,OnDestroy {
  mobileQuery: MediaQueryList;
  isSmallScreen = false;
  isHideTitle = false;
  logoSistema = LOGO_SISTEMA;
  logoSistemaTexto = LOGO_SISTEMA_TEXTO;
  ambiente: string = environment.ambiente;
  private readonly _mobileQueryListener: () => void;

  constructor(
    private readonly router: Router,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
    private readonly el: ElementRef, 
    private readonly renderer: Renderer2,
    private readonly sidenavService: SidenavService,
    private readonly authService: AuthService
  ) {
    this.checkScreenSize();
    this.mobileQuery = media.matchMedia('(min-width: 1024px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }

  private checkScreenSize() {
    this.isSmallScreen = window.innerWidth < 900; // Cambia el valor según tu criterio de "pequeño"
    this.isHideTitle = window.innerWidth < 1285;
  }

  shouldHideImage() {
    return this.isSmallScreen;
  }

  shouldHideTitle() {
    return this.isHideTitle;
  }

  async ngOnInit() {    
    if(!await this.authService.validateLocalSession()) {
      this.router.navigate(['/']);
    } else {
      this.checkScreenSize();
    }
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  toggleSidenav() {  
     if (this.sidenavService.sidenavWidth === SideNavCls) {
      this.sidenavService.setSidenavWidth(SideNavOpn);
      const elementosHid = this.el.nativeElement.querySelectorAll('.hid');
      elementosHid.forEach((elemento : HTMLElement) => {
        this.renderer.setStyle(elemento, 'display', 'block');
      });
    } else {
      this.sidenavService.setSidenavWidth(SideNavCls);    
      const elementosHid = this.el.nativeElement.querySelectorAll('.hid');
      elementosHid.forEach((elemento : HTMLElement) => {
        this.renderer.setStyle(elemento, 'display', 'none');
      });
    } 
  }

  get sidenavWidth() {
    return this.sidenavService.sidenavWidth;
  }
}